/* global gtag_ks_tracking, gtag */
'use strict';

class Gdpr {
    init() {

        if (document.body.classList.contains("cookie-consent-required") && !document.body.classList.contains("app-ios")) {

            this.attachBanner()

            this.attachEvents()

        } else {

            this.removeCookie("cookie-consent")

        }

    }

    cookieNames() {
        return {
            marketing: ["_fbp", "fr", "tr", "_gcl_au", "ads/ga-audiences", "IDE", "pagead/1p-conversion/#", "pagead/1p-user-list/#"],
            analytics: ["_ga", "_gid", "_gat", "_ym_d", "_ym_uid", "yandexuid", "i", "ymex", "gdpr", "is_gdpr", "is_gdpr_b"],
        }
    }

    defaultValues() {
        return {
            choices: {
                necessary: true,
                marketing: !(Cookie().get('_ks_osx_tracking_permission') === false || document.querySelector('body').classList.contains('disable-marketing-cookies') || document.querySelector('body').classList.contains('disable-analytics-cookies')),
                analytics: !(Cookie().get('_ks_osx_tracking_permission') === false || document.querySelector('body').classList.contains('disable-marketing-cookies') || document.querySelector('body').classList.contains('disable-analytics-cookies')),
                tracking: false
            }
        }

    }

    cookieName() {
        return "cookie-consent"
    }

    cookieConfig() {
        return {
            domain: location.origin.replace(/(http|https):\/\//, ''),
            path: '/'
        }
    }

    removeCookie(key) {
        const expires = new Date();
        expires.setDate(expires.getDate() + 365);
        const options = Object.assign({}, this.cookieConfig(), {expires});

        Cookie().remove(key, options)
    }

    removeCookies(key) {
        const cookies = this.cookieNames()[key];

        for (let i = 0; i < cookies.length; i++) {

            Cookie().remove(cookies[i]);

        }
    }

    setCookie(values) {
        const expires = new Date();
        expires.setDate(expires.getDate() + 365);
        const options = Object.assign({}, this.cookieConfig(), {expires});

        Cookie().set(this.cookieName(), values, options)
    }

    updateCookie(key, value) {

        const values = Object.assign(this.defaultValues(), Cookie().get(this.cookieName()));

        if (values) {

            values.choices[key] = value;

            this.setCookie(values)

        }

    }

    options() {
        const _class = this;

        return {
            /**
             * You must set the cookie name.
             **/
            cookieName: _class.cookieName(),

            /**
             * The cookie configuration, such as domain and path.
             **/
            cookieConfig: _class.cookieConfig(),

            /**
             * These are the top two lines of text on the banner
             * The 'description' field can include html such as links
             **/
            heading: translates.gdpr.heading,
            description: translates.gdpr.description,

            /**
             * All the button labels
             **/
            acceptLabel: translates.gdpr.acceptLabel,
            settingsLabel: translates.gdpr.settingsLabel,
            closeLabel: translates.gdpr.closeLabel,

            /**
             * These are the default opt-ins and their descriptions.
             * When value is set to true, the option will automatically be checked on load.
             *
             * If you don't want to show a category, simply remove the specified key from this object.
             **/
            choices: {
                necessary: {
                    label: translates.gdpr.necessary.label,
                    description: translates.gdpr.necessary.description,
                    value: true
                },
                analytics: {
                    label: translates.gdpr.analytics.label,
                    description: translates.gdpr.analytics.description,
                    value: !(Cookie().get('_ks_osx_tracking_permission') === false || document.querySelector('body').classList.contains('disable-marketing-cookies') || document.querySelector('body').classList.contains('disable-analytics-cookies'))
                },
                marketing: {
                    label: translates.gdpr.marketing.label,
                    description: translates.gdpr.marketing.description,
                    value: !(Cookie().get('_ks_osx_tracking_permission') === false || document.querySelector('body').classList.contains('disable-marketing-cookies') || document.querySelector('body').classList.contains('disable-analytics-cookies'))
                },
                tracking: false
            },

            /**
             * Show an icon to edit cookies later, when banner is closed.
             **/
            showEditIcon: true,

            /**
             * These are the functions which are run if a user opts-in to that category.
             * You should drop your cookies here (or set a variable to control the later dropping of cookies.
             *
             * If you are using svelte, you can use events instead - see the Svelte section below.
             **/
            categories: {
                analytics: function () {
                    // console.log('No analytics cookies specified')

                    _class.changeAnalytics(null, true);
                },
                tracking: function () {
                    // console.log('No tracking cookies specified')
                },
                marketing: function (eee) {
                    // console.log('No marketing cookies specified')
                    _class.changeMarketing(null, true);
                },
                necessary: function () {
                    // console.log('No necessary cookies specified')
                }
            }
        }
    }

    attachBanner() {

        GdprConsent.attachBanner(document.body, this.options());

        const toggler = document.querySelector(".toggleCookiePreferences");
        if (toggler) {
            toggler.addEventListener("click", function () {

                document.querySelector(".cookieConsentToggle").click()

            });
        }

    }

    attachEvents() {
        const _class = this;

        document.addEventListener("click", function (event) {
            const el = event.target;

            if (el.classList.contains("cookieConsent__Button")) {

                setTimeout(function () {

                    if (el.type === "button") {

                        document.querySelector("#gdpr-check-marketing").addEventListener("change", _class.changeMarketing);

                        document.querySelector("#gdpr-check-analytics").addEventListener("change", _class.changeAnalytics);

                    } else if (el.type === "submit" && !el.classList.contains("cookieConsent__Button--Close")) {

                        _class.changeMarketing(null, document.querySelector("#gdpr-check-marketing") ? document.querySelector("#gdpr-check-marketing").checked : true);

                        _class.changeAnalytics(null, document.querySelector("#gdpr-check-analytics") ? document.querySelector("#gdpr-check-analytics").checked : true);

                    } else if (el.type === "submit" && el.classList.contains("cookieConsent__Button--Close")) {

                        document.querySelector(".cookieConsent__Right [type=submit]").click();

                    }

                }, 100);

            }
        });
    }

    changeMarketing(event, checked) {

        if (event) {

            checked = event.target.checked;

        }

        if (checked) {

            console.log("marketing enabled")

        } else {

            new Gdpr().removeCookies("marketing");
            console.log("marketing disabled")

        }

        new Gdpr().updateCookie("marketing", checked)

    }

    changeAnalytics(event, checked) {

        if (event) {

            checked = event.target.checked;

        }

        if (checked) {

            if (typeof gtag_ks_tracking !== "undefined") {

                gtag_ks_tracking('consent', 'update', {
                    'ad_storage': 'granted',
                    'analytics_storage': 'granted',
                });

            }

            if (typeof gtag !== "undefined") {

                gtag('consent', 'update', {
                    'ad_storage': 'granted',
                    'analytics_storage': 'granted',
                });

            }

        } else {

            if (typeof gtag_ks_tracking !== "undefined") {

                gtag_ks_tracking('consent', 'update', {
                    'ad_storage': 'denied',
                    'analytics_storage': 'denied',
                });

            }

            if (typeof gtag !== "undefined") {

                gtag('consent', 'update', {
                    'ad_storage': 'denied',
                    'analytics_storage': 'denied',
                });

            }

            new Gdpr().removeCookies("analytics");

        }

        new Gdpr().updateCookie("analytics", checked)

    }
}

const gdpr = new Gdpr();

gdpr.init();


window.onload = function () {

    setTimeout(function () {
        const consent = document.querySelector('body');

        if (Cookie().get('_ks_osx_tracking_permission') === true) {

            gdpr.changeAnalytics(null, true);

            gdpr.changeMarketing(null, true);

        } else if (Cookie().get('_ks_osx_tracking_permission') === false || consent.classList.contains('disable-marketing-cookies') || consent.classList.contains('disable-analytics-cookies')) {

            gdpr.changeAnalytics(null, false);

            gdpr.changeMarketing(null, false);

        }

    }, 2000);

}
